import axios from '@fs/zion-axios'
import { SG_BASE_URL, headers } from '../config'
import { errorCollector } from '../../utils/utils'

// Resource: https://sg32i0.familysearch.org/service/standards/place/ws/places/reps/164/names/en

/**
 * Request the name of a place according to a language
 * @params placeCode - the code for the place (i.e. 164)
 * @params language - the language of the user (i.e. en)
 * @returns {Promise} Promise containing an object in this format:
 * { "displayName": { "name": "Argentina", "locale": "en" } }
 */
export default async function getPlaceName(placeCode, language) {
  const url = `${SG_BASE_URL}/service/standards/place/ws/places/reps/${placeCode}/names/${language}`
  return axios
    .get(url, { headers })
    .then(({ data }) => data)
    .catch((err) => {
      errorCollector(err, null, {
        codeId: 88,
        url,
        status: err?.response?.status,
        responseBody: err?.response?.data,
      })
      throw new Error(err)
    })
}
